import { Box, createStyles, makeStyles } from '@material-ui/core'
import { Label } from '@noco/http-client/lib/noco'
import React, { useMemo } from 'react'
import { Colors, DocumentLabelItem, Typography } from 'src/components/atoms'

export interface LabelCellProps {
  /** 複数ラベル対応（新） */
  labels?: Label[]
  /** 後方互換性のためのラベル名（旧） */
  value?: string
  /** 表示する最大ラベル数 */
  maxDisplay?: number
}

const useStyles = makeStyles(() => {
  return createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      overflow: 'hidden'
    },
    labelWrapper: {
      flexShrink: 0,
      marginRight: '4px',
      '&:last-child': {
        marginRight: 0
      }
    },
    moreLabel: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      borderRadius: '4px',
      padding: '4px 8px',
      backgroundColor: Colors.background.gray,
      whiteSpace: 'nowrap'
    }
  })
})

export const LabelCell = ({ labels, value, maxDisplay = 3 }: LabelCellProps) => {
  const classes = useStyles()

  const displayLabels = useMemo(() => {
    if (labels && labels.length > 0) {
      return labels.slice(0, maxDisplay)
    }
    return []
  }, [labels, maxDisplay])

  const remainingCount = useMemo(() => {
    if (labels && labels.length > maxDisplay) {
      return labels.length - maxDisplay
    }
    return 0
  }, [labels, maxDisplay])

  // 後方互換性：labelsがない場合は旧valueを使用
  if (!labels || labels.length === 0) {
    if (value) {
      return (
        <Box className={classes.root}>
          <DocumentLabelItem value={value} />
        </Box>
      )
    }
    return null
  }

  return (
    <Box className={classes.root}>
      {displayLabels.map((label, index) => (
        <span key={label.id || `label-${index}`} className={classes.labelWrapper}>
          <DocumentLabelItem label={label} />
        </span>
      ))}
      {remainingCount > 0 && (
        <span className={classes.moreLabel}>
          <Typography fontSize="s" lineheight="14px">
            +{remainingCount}
          </Typography>
        </span>
      )}
    </Box>
  )
}
